<template>
  <div class="user-management">
    <div class="d-flex wrap gap-10">
      <!-- 用户类型 -->
      <div class="d-flex">
        <label class="mr5">用户类型</label>
        <el-select
          class="input200"
          v-model="queryParams.user_type"
          clearable
          :placeholder="`请选择`"
          @change="userTypeChange">
          <el-option
            v-for="item in userTypes"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <!-- 经销商名称 -->
       <div class="d-flex" v-if="queryParams.user_type === 1">
        <label class="mr5">经销商名称</label>
        <el-select
          class="input200"
          v-model="queryParams.dealer_id"
          remote
          filterable
          clearable
          :remote-method="getDealerSelect"
          @focus="getDealerSelect()">
          <el-option
            v-for="item in dealerOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"></el-option>
        </el-select>
       </div>
      <!-- 租户名称 -->
      <div v-if="user.is_super_tenant_admin && queryParams.user_type === 0" class="d-flex">
        <label class="mr5">租户名称</label>
        <tenantSelection @clickTenant="getTenantInfo" :data="tenantData" @inputClear="inputClear"></tenantSelection>
        <!-- <el-cascader
            :before-filter="remoteSearch"
            filterable
            :options="address"
            :show-all-levels="false"
            clearable
            v-model="queryParams.tenant_id"
            :props="{
              label: 'name',
              value: 'code',
              emitPath:false
            }"
            popper-class="cascader-style"
            @expand-change="expandChange"
            >
          </el-cascader> -->
        <!-- <el-select
          class="input200"
          v-model="queryParams.tenant_id"
          remote
          filterable
          clearable
          :remote-method="getTenantsOpts"
          @focus="getTenantsOpts()"
        >
          <el-option
            v-for="item in tenantOpts"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select> -->
      </div>

      <div class="d-flex">
        <label class="mr5">状态</label>
        <el-select
          class="input200"
          v-model="queryParams.status"
          clearable
        >
          <el-option
            v-for="item in statusOpts"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="d-flex">
        <label class="mr5">手机</label>
        <el-input
          class="input200"
          v-model="queryParams.mobile"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </div>

      <div class="d-flex">
        <label class="mr5">用户账号</label>
        <el-select
          class="input200"
          v-model="queryParams.username"
          remote
          filterable
          clearable
          :remote-method="getUserOptsByUsername"
          @focus="getUserOptsByUsername()"
        >
          <el-option
            v-for="item in userOpts"
            :key="item.id"
            :label="item.username"
            :value="item.username">
          </el-option>
        </el-select>
      </div>

      <div class="d-flex">
        <label class="mr5">用户姓名</label>
        <el-select
          class="input200"
          v-model="queryParams.name"
          remote
          filterable
          clearable
          :remote-method="getUserOptsByName"
          @focus="getUserOptsByName()"
        >
          <el-option
            v-for="item in userOpts"
            :key="item.index"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </div>

      <el-button
        class="ml10"
        type="primary"
        size="small"
        @click="search"
      >查询</el-button>

      <el-button
        type="primary"
        size="small"
        @click="openCreate()"
      >新增</el-button>

      <el-button
        type="primary"
        size="small"
        @click="handleExport"
      >导出</el-button>
    </div>

    <div class="page-card">
      <el-table
        class="mt10"
        border
        @sort-change="sortChange"
        :data="list">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column
          v-for="(item) in headers"
          :key="item.id"
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :width="item.width">
          <template slot-scope="scope">
            <template v-if="item.prop === 'handle'">
              <el-button
                type="text"
                @click="openEdit(scope.row)"
              >
                编辑
              </el-button>

              <el-button
                type="text"
                @click="openView(scope.row)"
              >
                详情
              </el-button>

              <el-button
                type="text"
                @click="handleDel(scope.row)"
              >
                删除
              </el-button>
              <el-button
                v-if="user.is_super_tenant_admin"
                type="text"
                @click="SMSNotification(scope.row)"
              >
                短信通知
              </el-button>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>

    <edit
      ref="Edit"
      @fresh="getList"
    />
  </div>
</template>

<script>
import tenantSelection from '@/components/common/tenantSelection'
import {
  mapGetters
} from 'vuex';
import Pagination from '@/components/common/Pagination';
import Edit from './components/edit.vue';
import {
  getTenantOpts,
  getUserOpts,
  userManage,
  userDelete,
  userSms,
  dealerSelect
} from '@/api.js'; 
import {
  pageSize
} from '@/utils/Config.js';
export default {
  name: 'UserManagement',
  components: {
    Pagination,
    Edit,
    tenantSelection
  },
  computed: {
    ...mapGetters([ 'user','addressOptions' ]),
    address(){
      // 区县下一级列表初始化
      let arr = this.$utils.deepCopy(this.addressOptions)
                  // 避免重复做处理
                  for (const item of arr) {
        item.code = item.code + 'code'
      }
      for (const province of arr) {
        for (const city of province.children) {
          for (const county of city.children) {
            this.$set(county,'children',[])
          }
        }
      }
      this.tenantOpts.forEach(item => {
        const province = arr.find(i => i.code === item.province + 'code')
        if (province) {
          const city = province.children.find(i => i.code === item.city)
          if (city) {
            const county = city.children.find(i => i.code === item.area)
            if (county) {
              county.children.push({
                name: item.name,
                code: item.id
              })
            }
          }
        }
      })
      return arr
    }
  },
  data() {
    return {
      tenantData:{
        inputData:'',
        clearable:true
      },
      queryParams: {
        pageIndex: 1,
        pageSize,
        _total: 0,
      },
      tenantOpts: [],
      userOpts: [],
      statusOpts: [
        {
          name: `正常`,
          value: 1
        },
        {
          name: `冻结`,
          value: 2
        }
      ],
      headers: [],
      list: [],
      userTypes: [
        {
          name: `经销商用户`,
          value: 1
        },
        {
          name: `租户用户`,
          value: 0
        }
      ],
      dealerOptions: []
    }
  },
  methods: {
    getTenantInfo(data){
      this.queryParams.tenant_id = data.id
      this.tenantData.inputData = data.name
    },
    inputClear(){
      this.queryParams.tenant_id = ''
    },
    userTypeChange(type) {
      if (type === 1) {
        this.$set(this.queryParams, 'tenant_id', undefined)
        this.tenantData.inputData = ''
      } else {
        this.$set(this.queryParams, 'dealer_id', undefined)
      }
    },
    getDealerSelect(name = ''){
      return this.$request('get', dealerSelect, { country: this.user.country, name,struct: 1 })
      .then((res) => {
        this.dealerOptions = res
      })
    },
    getTenantsOpts(name = null , area = null , province = null , city = null) {
      return this.$request('get', getTenantOpts, { name,province,city,area })
      .then(res => {
        this.tenantOpts = res || []
      })
    },
    getUserOpts(name = undefined, username = undefined) {
      const {
        tenant_id
      } = this.queryParams
      const query = {
        tenant_id,
        username,
        name,
        is_auto:1
      }
      return this.$request('get', getUserOpts, query)
    },
    getUserOptsByName(name = undefined) {
      // 通过用户姓名查询
      this.getUserOpts(name, undefined)
      .then(res => {
        const nameList = res && res.length ? [...new Set(res.map(i => i.name))] : []
        this.userOpts = nameList.map((i, d) => {
          return {
            index: d,
            name: i
          }
        })
      })
    },
    getUserOptsByUsername(name = undefined) {
      // 通过用户账号查询
      this.getUserOpts(undefined, name)
      .then(res => {
        this.userOpts = res || []
      })
    },
    getList() {
      const {
        tenant_id,
        name,
        username,
        mobile,
        pageIndex,
        pageSize,
        order,
        orderBy,
        status,
        user_type,
        dealer_id
      } = this.queryParams
      const query = {
        status,
        user_type: user_type === "" ? undefined : user_type,
        dealer_id,
        tenant_id,
        name,
        username,
        mobile,
        page: pageIndex,
        per_page: pageSize,
        order,
        order_column: orderBy
      }
      this.$request('get', userManage, query)
      .then(res => {
        if (res) {
          const {
            data,
            columns,
            total
          } = res
          
          this.list = data
          this.headers = this.$utils.generateColumns(columns)
          this.queryParams._total = total
        }
      })
    },
    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
      const orderBy = order ? column.sortBy : undefined

      this.queryParams.order = orderString
      this.queryParams.orderBy = orderBy
      this.getList()
    },
    search() {
      this.queryParams.pageIndex = 1
      this.getList()
    },
    async handleDel(item) {
      const confirm = await this.$confirm(`确认删除吗?`)
      if (!confirm) return

      const {
        id
      } = item
      const url = userDelete.replace('{id}', id)
      this.$request('post', url)
      .then(res => {
        if (res) {
          this.$message.success(`操作成功`)
          this.getList()
        }
      })
    },
    //短信通知
    SMSNotification(data){
      this.$confirm(`确定发送通知短信吗？`, `提示`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        type: 'warning'
      }).then(() => {
        this.$request('post',userSms,{
          id:data.id
        }).then(res=>{
          if(res){
            this.$message({
              type: 'success',
              message: `操作成功`
            });
          }
        })
      })
    },
    openCreate() {
      // 新增
      const {
        Edit
      } = this.$refs

      Edit && Edit.open({
        tenant_text:''
      })
    },
    openEdit(detail) {
      // 编辑
      const {
        Edit
      } = this.$refs
      const {
        id,
        tenant_text
      } = detail
      Edit && Edit.open({ id,tenant_text })
    },
    openView(detail) {
      // 查看详情
      const {
        Edit
      } = this.$refs
      const {
        id,
        tenant_text
      } = detail

      Edit && Edit.open({ id, isView: true,tenant_text })
    },
    handleExport() {
      const {
        tenant_id,
        name,
        username,
        mobile,
        pageIndex,
        pageSize,
        order,
        orderBy,
        user_type,
        dealer_id
      } = this.queryParams
      const params = {
        user_type,
        dealer_id,
        tenant_id,
        name,
        username,
        mobile,
        page: pageIndex,
        per_page: pageSize,
        order,
        order_column: orderBy,
        is_export: 1
      }

      this.$utils.exportFile(userManage, params)
    },
    async remoteSearch(value){
      let res = await this.$request('get', getTenantOpts, { name:value })
      this.tenantOpts = res || []
    },
    expandChange(node){
      if (node[2]) {
        this.getTenantsOpts(null,node[2])
      }
    }
  },
  created() {
    // this.getTenantsOpts()
    this.getList()
  }
}
</script>

<style>

</style>